import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { ChurchBookAuthService } from './church-book-auth.service';
import {
  ChurchBookSearchType,
  ChurchBookOperator,
  ChurchBookSearchResponse,
  ChurchBookSearchRequest,
} from '../../common/models/church-book/church-book.models';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ChurchBookSearchService {
  private readonly url = `${environment.churchBook.apiUrl}/api/v1/search/advanced`;

  constructor(private http: HttpClient, private auth: ChurchBookAuthService) {}

  search(
    searchType: ChurchBookSearchType,
    field: string,
    operator: ChurchBookOperator,
    value: string | number,
    offset: number = 0
  ): Observable<ChurchBookSearchResponse> {
    return from(this.auth.ensureToken()).pipe(
      switchMap(token => this.doSearch(token, searchType, field, operator, value, offset)),
      catchError(err => {
        if (err.status === 401) {
          return from(this.auth.invalidate()).pipe(
            switchMap(() => from(this.auth.ensureToken())),
            switchMap(token => this.doSearch(token, searchType, field, operator, value, offset))
          );
        }
        throw err;
      })
    );
  }

  private doSearch(
    token: string,
    searchType: ChurchBookSearchType,
    field: string,
    operator: ChurchBookOperator,
    value: string | number,
    offset: number
  ): Observable<ChurchBookSearchResponse> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    const body: ChurchBookSearchRequest = {
      search_type: searchType,
      filter_group: { logic: 'AND', conditions: [{ field, operator, value }] },
      limit: 20,
      offset,
    };
    return this.http.post<ChurchBookSearchResponse>(this.url, body, { headers });
  }
}
